<template>
    <div class="wrap">
        <div class="p-t-sm">
            <div class="container clearfix company">
                <div class="row">
                    <div class="slider hide">
                        <ul class="nav">
                            <router-link :to="{'path':'/company/dashboard'}" tag="li" class="item" active-class="active">控制台</router-link>
                            <router-link :to="{'path':'/company/organizations'}" tag="li" class="item" active-class="active" v-if="user.category === 2">组织机构</router-link>
                            <router-link :to="{'path':'/company/hr'}" tag="li" class="item" active-class="active" v-if="user.category === 2">HR管理</router-link>
                            <router-link :to="{'path':'/company/posts'}" tag="li" class="item" active-class="active">岗位管理</router-link>
                            <router-link :to="{'path':'/company/invitations'}" tag="li" class="item" active-class="active">测评邀请</router-link>
                            <router-link :to="{'path':'/company/setting'}" tag="li" class="item" active-class="active" v-if="user.category === 2">企业设置</router-link>
                        </ul>
                    </div>
                    <div class="content m-t-sm" style="min-height:520px;">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <div class="compare-bar" :class="{show:showCompare == 1}">
            <div class="container">
                <div class="bar-title clearfix">
                    <div class="tab current">
                        对比栏
                    </div>
                    <a href="javascript:;" class="tab right small color-default" @click="hideBar()">
                        隐藏
                    </a>
                </div>
                <div class="bar-body">
                    <div class="row">
                        <div class="col-sm-10 col-xs-12">
                            <ul class="row resumes">
                                <li class="list-item col-xs-12 col-sm-3" v-for="(resume,ind) in resumes" :key="resume.code">
                                    <div v-if="resume.code">
                                        <div class="p-b-xs">{{resume.user.realname}}</div>
                                        <div class="p-b-xs">{{resume.user.phone}}</div>
                                        <div class="p-b-xs">{{resume.post}}</div>
                                        <div class="p-b-xs">{{resume.score}}分</div>
                                        <div class="text-right">
                                            <a href="javascript:;" class="btn btn-xs btn-danger" @click="delResume(ind)">
                                                删除
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-2 col-xs-12 text-center">
                            <div class="row p-t-b-sm">
                                <div class="col-xs-6 col-sm-12 p-t-b-sm">
                                    <div class="row">
                                        <button class="btn btn-sm" :class="{'btn-primary':compareIds,'btn-disabled': !compareIds}" type="button" :disabled="!compareIds" @click="compare()">对比</button>
                                    </div>
                                </div>
                                <div class="col-xs-6 col-sm-12 p-t-b-sm">
                                    <div class="row">
                                        <a href="javascript:;" class="tab small color-default" @click="clearBar">
                                            清空对比栏
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "loginUser",
      resumes: "compareReumes",
      showCompare: "showCompare",
      selectPost: "seletePost"
    }),
    compareIds: function() {
      const that = this;
      let r = that.resumes.reduce((pre, val) => {
        if (val.code) {
          pre.push(val.code);
        }
        return pre;
      }, []);
      if (r.length > 1) {
        return r.join("-");
      } else {
        return "";
      }
      return "";
    }
  },
  created: function() {
    let that = this;
    if (
      that.user.category === 2 ||
      (that.user.category === 1 &&
        (that.user.role === 2 || that.user.role === 3))
    ) {
      that.$store.dispatch("setViewType", 2); // 公司视图
    } else {
      // 回到首页
      that.$router.replace("/");
    }
  },
  methods: {
    clearBar: function() {
      const that = this;
      that.$store.dispatch("clearCompareResumes");
    },
    delResume: function(index) {
      const that = this;
      that.$store.dispatch("delCompareResume", index);
    },
    hideBar: function() {
      const that = this;
      that.$store.dispatch("hideCompareResumesBar");
    },
    compare: function() {
      const that = this;
      that.$router.push({
        name: "CompanyCompare",
        params: { ids: that.compareIds }
      });
      that.hideBar();
    }
  },
  destroyed: function() {
    let that = this;
    that.$store.dispatch("setViewType", 1); // 个人试图
  }
};
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// company.vue?fb687ab6